import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useCaptureException } from '@zenbusiness/application-commons-logging';

import { useAccountSettings } from './useAccountSettings';

export const LEAD_QUERY_BY_EMAIL = gql`
  query LeadDetailsQuery($email: Email!) {
    leadV2(filter: { email: $email }) {
      uuid
      firstName
      lastName
      email
      phone
      entityName
      entityType
      jurisdictionCode
      flowName
      planFlow
    }
  }
`;

export function useLeadDetails() {
  const { data: accountInfo, loading: accountLoading } = useAccountSettings();
  const captureException = useCaptureException();

  const email = accountInfo?.accountEmail;

  const {
    data, loading: leadLoading, error
  } = useQuery(LEAD_QUERY_BY_EMAIL, {
    noThrow: true,
    skip: !email, // Skip the query when email is not available
    variables: {
      email
    }
  });

  const normalizedError = error ?? null;

  if (normalizedError && normalizedError.errorCode !== 'LEAD_NOT_FOUND') {
    captureException(normalizedError);
  }

  return {
    data: data?.leadV2 || {},
    error: normalizedError,
    loading: accountLoading || (email && leadLoading)
  };
}
